import { useMsal } from "@azure/msal-react";
import { loginRequest, protectedResources } from "../authConfig";

export async function getToken(skid){
    const { instance, accounts, inProgress } = useMsal();
    const request = {
        scopes: protectedResources.whoami.scopes,
        account: accounts[0],
      };
    const instanceToken = await instance.acquireTokenSilent(request) ;
     //const url = new URL("https://rheo-api.azurewebsites.net/token")
    const url = new URL("http://localhost:8000/token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + instanceToken);
    
    const options = {
        method: "GET",
        headers: headers
      };
      url.search = new URLSearchParams({
       skid: skid
     });
    const response = await fetch(url,options);
    const socketToken = response.json().body.token;
    console.log("Socket token: ",socketToken)
    return socketToken
}

export default getToken;